/**
 * Flattens the semantic colors object into a single level of keys.
 *
 * @param colors - The semantic colors object to flatten.
 *
 * @returns A flattened object with keys in the format of [elementType]-[priorityOrMood]-[level].
 */
export const flattenSemanticColors = (colors: Record<string, any>): Record<string, string> => {
  return Object.entries(colors).reduce(
    (acc, [elementType, topLevelValue]) => {
      Object.entries(topLevelValue as Record<string, Record<string, string>>).forEach(
        ([priorityOrMood, midLevelValue]) => {
          Object.entries(midLevelValue as Record<string, string>).forEach(([level, value]) => {
            acc[`${elementType}-${priorityOrMood}-${level}`] = value;
          });
        }
      );
      return acc;
    },
    {} as Record<string, string>
  );
};

/**
 * Flattens the component color tokens object into a single level of keys.
 *
 * @param colors - The component color tokens object to flatten.
 *
 * @returns A flattened object with keys in the format of [componentType]-[tokenType]-[state].
 */
export const flattenComponentColorTokens = (
  colors: Record<string, any>
): Record<string, string> => {
  return Object.entries(colors).reduce(
    (acc, [componentType, topLevelValue]) => {
      Object.entries(topLevelValue as Record<string, Record<string, string>>).forEach(
        ([tokenType, midLevelValue]) => {
          Object.entries(midLevelValue as Record<string, string>).forEach(([state, value]) => {
            acc[`${componentType}-${tokenType}-${state}`] = value;
          });
        }
      );
      return acc;
    },
    {} as Record<string, string>
  );
};
